import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";
import ContentItem from '../../components/ContentItem';

class MyLeague extends Component {
  state = {
    gotoPage: 1,
    dataList: [],
  };
  componentDidMount = () => {
    //this._getData(1)
  };

  _getData = async (gotoPage) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi(gotoPage);
      const intReturn = result.data[0].intReturn;
      const pageCount = result.data[0].pageCount;
      const con = result.data[0].con;
      const dataList = result.data[0].listData;
      //console.log(con)
      if (intReturn === 0) {
        if (con > 0) {
          //console.log('con > 0')
          this.setState({
            gotoPage: gotoPage + 1,
            con: con,
            dataList:
              gotoPage === 1 ? dataList : this.state.dataList.concat(dataList),
            hasMore: pageCount < gotoPage ? false : true,
          });
        } else {
          //console.log('con < 0')
          this.setState({
            gotoPage: 1,
            con: con,
            searchList: dataList,
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      } else {
        //console.log('intReturn <> 0')
        this.setState({
          gotoPage: 1,
          con: con,
          dataList: [],
          hasMore: pageCount < gotoPage ? false : true,
        });
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/myZzim', {
        params: {
          userid: loginId,
          gotoPage: gotoPage,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <div key={index} style={{ display: 'inline-block' }}>
          <ContentItem
            refer={'sametime'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            onInit={this._getData}
          />
        </div>
        /*
                <div className="div_li">
                    <div className="dataList_img_bg"><img src="/img/test_img8.png"/></div>
                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                </div>
                */
      );
    });

    return list;
  };
  _onAllDelete = () => {
    const { dataList } = this.state;
    if (dataList.length <= 0) {
      toast.warn('삭제할 작품이 존재하지 안습니다.');
      return;
    }

    confirmAlert({
      title: '찜하기 전체 삭제',
      message:
        '찜해놓은 모든 작품을 삭제하시겠습니까? 삭제된 데이터는 복구 되지 않습니다.',
      buttons: [
        {
          label: '모두 삭제',
          onClick: async () => {
            const result = await this._onAllDeleteApi();
            const intReturn = result.data[0].intReturn;

            if (intReturn === 0) {
              toast.success('찜한 작품이 모두 삭제 되었습니다.');
              this._getData(1);
            } else {
              toast.warn('삭제할 작품이 존재하지 안습니다.');
            }
          },
        },

        {
          label: '취소',
          //onClick: () => alert('Click No')
        },
      ],
    });
  };
  _onAllDeleteApi = () => {
    // const { apiUrl, loginId, dataList } = this.props;
    /*
        return axios.post(apiUrl + '/myZzimAllDel', {
            params: {
                userid: loginId
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
        */
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { con } = this.state;
    return (
      <Fragment>
        <div className="mypage_content">
          <div className="mypage_group">
            <h1>
              리그 투표권<span>({con})</span>
              <div></div>
            </h1>
            <div className="my_table_list">
              <table
                width="100%"
                border="0"
                cellSpacing="0"
                cellPadding="0"
                className="style_table2"
              >
                <colgroup>
                  <col width="9%" />
                  <col width="11%" />
                  <col width="" />
                  <col width="11%" />
                  <col width="13%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>구분</th>
                    <th>날짜</th>
                    <th>투표내역</th>
                    <th>사용내역</th>
                    <th>투표권 획득</th>
                  </tr>
                  <tr>
                    <td>
                      <span className="color_1">사용</span>
                    </td>
                    <td>2020.07.01</td>
                    <td>
                      <div>
                        렙<em>2,2564</em>
                        <p>RE:제로부터 시작하는 이세계 생활</p>
                      </div>
                    </td>
                    <td>
                      <span className="color_1">- 2장</span>
                    </td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="color_3">획득</span>
                    </td>
                    <td>2020.07.01</td>
                    <td>
                      <div>
                        렙<em>2,2564</em>
                        <p>RE:제로부터 시작하는 이세계 생활</p>
                      </div>
                    </td>
                    <td>-</td>
                    <td>
                      <span className="color_3">+ 2장</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="color_3">획득</span>
                    </td>
                    <td>2020.07.01</td>
                    <td>
                      <div>로그인</div>
                    </td>
                    <td>-</td>
                    <td>
                      <span className="color_3">+ 2장</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyLeague));
